module.exports = __webpack_public_path__ + "f578a01e67de82c40add0acf9a94bc01.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1038
// module chunks = 0